import { Folder } from '@/api';

export type JiraJqlWorkstreamMapping = {
  uid: string;
  jql: string;
  workstreamNumber: Folder['number'];
};

export enum JiraSupportedCustomFieldBaseType {
  DATE = 'date',
  DATETIME = 'datetime',
  STRING = 'string',
  NUMBER = 'number',
  OPTION = 'option',
  ARRAY = 'array',
  USER = 'user',
  ANY = 'any',
}
export enum JiraSupportedCustomFieldSubType {
  USER_PICKER = 'userpicker',
  MULTI_USER_PICKER = 'multiuserpicker',
  MULTI_CHECKBOXES = 'multicheckboxes',
  MULTI_SELECT = 'multiselect',
  PEOPLE = 'people',
  TEXTAREA = 'textarea',
  URL = 'url',
}
